








export default
  name: 'FullScreenModal'
  props: ['show']
